import Toggle from 'react-toggle';
import "react-toggle/style.css";
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

const SwitchWrap = styled.div`
  display: flex;
  font-family: Gordita;
  margin-bottom: 2em;

  .react-toggle-track {
    width: 58px;
    height: 30px;
  }

  .react-toggle-trackhover {
    background-color: inherit;
  }

  .react-toggle-thumb {
    border: 0;
    width: 28px;
    height: 28px;
  }

  .react-toggle--checked:hover:not(.react-toggle--disabled)
    .react-toggle-track {
    background-color: #ff4256;
  }

  .react-toggle--checked .react-toggle-track {
    background: #ff4256;
  }
  .react-toggle--checked .react-toggle-thumb {
    left: 29px;
  }
`;

const SwitchText = styled.div`
    display: flex;
    flex-direction: column;
    margin-right: 2em;
`;

const SwitchHelpText = styled.p`
    font-size: 0.85em;
    color: #ADADAD;
`;

const SwitchLabel = styled.label`
    font-size: ${props => props.size === 'large' ? '1.4em' : '1em'};
    font-weight: 500;
`;

const SwitchInput = (props) => {
    return (
      <SwitchWrap>
        <SwitchText>
          <SwitchLabel size={props.size}>{props.label}</SwitchLabel>
          <SwitchHelpText>{props.helpText}</SwitchHelpText>
        </SwitchText>
        <Toggle
          icons={false}
          defaultChecked={props.defaultChecked}
          onChange={props.toggleChange}
        />
      </SwitchWrap>
    );
}

SwitchInput.propTypes = {
  toggleChange: PropTypes.func.isRequired,
  size: PropTypes.string,
  defaultChecked: PropTypes.bool,
};

export default SwitchInput;